import React, { useEffect, useState } from "react";
import { Dropdown, Card, Table, Badge, Tab, Nav, Modal } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import FullImage from "../components/Modal/FullImage";
import {
  UpdateSupportStatus,
  deleteSupport,
  getHelpCenterSupportList,
  getSupportList,
  deleteHelpCenterSupport,
} from "../../services/UserServices/UserService";
import Pagination from "../components/Common/Pagination";
import Spinner from "../components/Common/Spinner";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";
import moment from "moment";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";

export default function SupportRequests(props) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const dataId = searchParams.get("data");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [attachmentForView, setAttachmentForView] = useState("");
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [deleteConfirmId, setDeleteConfirmId] = useState("");
  const [deleteConfirmType, setDeleteConfirmType] = useState("support"); // "support" | "helpCenter"
  const [sort, setSort] = useState(
    location?.state?.selectedTab.selectedTab
      ? location?.state?.selectedTab.selectedTab.toLowerCase()
      : "new"
  );
  const [datas, setDatas] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [detailsItem, setDetailsItem] = useState(null);
  const [listLength, setListLength] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    location?.state?.page ? location?.state?.page : 0
  );
  const [search, setSearch] = useState("");
  const [initialFetch, setInitialFetch] = useState(true);
  const [selectedTab, setSelectedTab] = useState(
    location?.state?.selectedTab
      ? location?.state?.selectedTab.selectedTab
      : "New"
  );

  const limit = 10;
  const imgBaseURL = "https://matchc.s3.ap-southeast-1.amazonaws.com/";

  const HELP_OPTIONS = [
    { value: "", label: "Select an option" },
    { value: "login", label: "Trouble with account login" },
    { value: "feature", label: "A MatchCatch feature isn't working" },
    { value: "safety", label: "I have a safety or privacy concern" },
    { value: "other", label: "Question about something else" },
  ];

  const CHARGE_ON_STATEMENT_OPTIONS = [
    { value: "", label: "-" },
    { value: "apple", label: "APPLE.COM/BILL" },
    { value: "google", label: "GOOGLE *MatchCatch (or similar)" },
    { value: "paypal", label: "PAYPAL *MATCHCATCH (or similar)" },
    { value: "stripe", label: "STRIPE / card descriptor with MatchCatch" },
    { value: "other", label: "Other / doesn’t match any of the above" },
  ];

  const PLATFORM_OPTIONS = [
    { value: "", label: "-" },
    { value: "android", label: "Android" },
    { value: "ios", label: "iOS" },
    { value: "web", label: "Web" },
  ];

  const FEATURE_TOPIC_OPTIONS = [
    { value: "", label: "-" },
    { value: "messaging", label: "chat" },
    { value: "discovery", label: "Discovery" },
    { value: "profile", label: "Profile or photos" },
    { value: "notifications", label: "Notifications" },
    { value: "settings", label: "Settings or preferences" },
    { value: "other", label: "Other" },
  ];

  const LOGIN_ISSUE_OPTIONS = [
    { value: "", label: "-" },
    { value: "banned", label: "My account was banned" },
    { value: "appeal_violation", label: "I want to appeal a violation" },
    { value: "other_login", label: "Other issue with login" },
    { value: "cant_verify", label: "I can't verify my email or phone number" },
    { value: "cant_delete", label: "I can't delete my account" },
    { value: "update_phone", label: "I need to update my phone number" },
    { value: "sign_up", label: "I can't sign up" },
  ];

  const helpOptionLabelByKey = (helpWith) => {
    if (!helpWith) return "";
    return HELP_OPTIONS.find((o) => o.value === helpWith)?.label || helpWith;
  };

  const optionLabel = (options, value) => {
    if (!value) return "";
    return options.find((o) => o.value === value)?.label || value;
  };

  const valueOrDash = (v) => {
    if (v === 0) return "0";
    if (v === false) return "false";
    if (v === null || v === undefined) return "-";
    const s = String(v).trim();
    return s.length ? s : "-";
  };

  const openDetails = (item) => {
    setDetailsItem(item || null);
    setShowDetailsModal(true);
  };

  const helpCenterTypeLabel = (item) => {
    const helpWith = item?.helpWith;
    if (helpWith === "login") return optionLabel(LOGIN_ISSUE_OPTIONS, item?.loginDetail);
    if (helpWith === "feature") return optionLabel(FEATURE_TOPIC_OPTIONS, item?.featureTopic);
    if (helpWith === "billing") return item?.billingDetail || "Billing";
    if (helpWith === "safety") return item?.safetyConcern || "Safety";
    return item?.helpWith || "";
  };

  const prettifyKey = (key) => {
    if (key === "helpWith") return "Help With";
    if (key === "loginDetail") return "Issue Type";
    if (key === "featureTopic") return "Feature Topic";
    if (key === "platform") return "Platform";
    if (key === "chargeOnStatement") return "Charge On Statement";
    if (key === "createdAt") return "Date";
    return String(key || "")
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/^./, (c) => c.toUpperCase());
  };

  const formatDetailsValue = (key, value, item) => {
    if (key === "helpWith") return helpOptionLabelByKey(value) || valueOrDash(value);
    if (key === "loginDetail") return optionLabel(LOGIN_ISSUE_OPTIONS, value) || valueOrDash(value);
    if (key === "featureTopic")
      return optionLabel(FEATURE_TOPIC_OPTIONS, value) || valueOrDash(value);
    if (key === "platform") return optionLabel(PLATFORM_OPTIONS, value) || valueOrDash(value);
    if (key === "chargeOnStatement")
      return optionLabel(CHARGE_ON_STATEMENT_OPTIONS, value) || valueOrDash(value);
    if (key === "type") return valueOrDash(helpCenterTypeLabel(item));
    if (key === "createdAt" || key === "updatedAt") {
      return value ? moment(value).format("DD/MM/YYYY HH:mm") : "-";
    }
    if (key === "hasSubscription" && typeof value === "boolean") {
      return value ? "Yes" : "No";
    }
    if (typeof value === "boolean") return value ? "true" : "false";
    if (Array.isArray(value)) return value.length ? value.join(", ") : "-";
    if (value && typeof value === "object") {
      try {
        return JSON.stringify(value, null, 2);
      } catch (e) {
        return valueOrDash(String(value));
      }
    }
    return valueOrDash(value);
  };
  //   const imgUrl = "https://closertech.s3.us-west-2.amazonaws.com/";
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  async function getTableData() {
    setLoader(true);
    try {
      // Help Center tab uses a different API
      if (selectedTab === "Help Center") {
        const response = await getHelpCenterSupportList(currentPage, limit);
        // API shape: { data: { support: [...], count: number } }
        setDatas(response.data.data?.support || []);
        const total = response.data.data?.count ?? 0;
        setPageCount(Math.ceil(total / limit));
        setListLength(total);
        setInitialFetch(false);
        setLoader(false);
        return;
      }

      if (dataId) {
        const response = await getSupportList(
          currentPage,
          limit,
          search,
          sort,
          dataId
        );
        setDatas(response.data.data?.list);
        setLoader(false);
        const total = response.data.data?.count;
        setPageCount(Math.ceil(total / limit));
        setListLength(response.data.data?.count);
        setInitialFetch(false);
      } else {
        const response = await getSupportList(currentPage, limit, search, sort);
        setDatas(response.data.data?.list);
        setLoader(false);
        const total = response.data.data?.count;
        setPageCount(Math.ceil(total / limit));
        setListLength(response.data.data?.count);
        setInitialFetch(false);
      }
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
    }
  }

  async function onDelete(id) {
    setLoader(true);
    try {
      const response = await deleteSupport(id);
      notifyTopRight(response.data?.message);
      getTableData();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "helooo");
      setLoader(false);
    }
  }

  async function onDeleteHelpCenter(id) {
    setLoader(true);
    try {
      const response = await deleteHelpCenterSupport(id);
      notifyTopRight(response.data?.message);
      setShowDetailsModal(false);
      setDetailsItem(null);
      getTableData();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      setLoader(false);
    }
  }

  const openDeleteConfirm = (id, type = "support") => {
    if (!id) return;
    setDeleteConfirmId(id);
    setDeleteConfirmType(type);
    setShowDeleteConfirmModal(true);
  };

  const closeDeleteConfirm = () => {
    setShowDeleteConfirmModal(false);
    setDeleteConfirmId("");
    setDeleteConfirmType("support");
  };

  const confirmDelete = async () => {
    if (!deleteConfirmId) return;
    const id = deleteConfirmId;
    const type = deleteConfirmType;
    closeDeleteConfirm();
    if (type === "helpCenter") return onDeleteHelpCenter(id);
    return onDelete(id);
  };

  async function onAction(id, status) {
    setLoader(true);
    try {
      const formData = { ticketId: id, status };
      const response = await UpdateSupportStatus(formData);
      notifyTopRight(response.data?.message);
      getTableData();
      console.log(response);
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "helooooooooo");
      setLoader(false);
    }
  }

  useEffect(() => {
    getTableData();
  }, [currentPage, sort, selectedTab, dataId]);

  let timeoutId;
  // Define a helper function for debouncing
  const debounce = (func, delay) => {
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getTableDataSearch = async () => {
    setCurrentPage(0);
    getTableData();
  };

  const tabData = [
    {
      name: "New",
      //   icon: "home",
      content: "New",
    },
    {
      name: "Ongoing",
      //   icon: "user",
      content: "In Progress",
    },
    {
      name: "Past",
      //   icon: "phone",
      content: "Resolved",
    },
    {
      name: "Search",
      //   icon: "phone",
      content: "Search",
    },
    {
      name: "Help Center",
      content: "Help Center",
    },
  ];

  const truncateWords = (text, wordLimit = 20) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  return (
    <div>
      <PageTitle
        activeMenu="Support List"
        motherMenu="Support Requests"
        previousPath={"/support-requests"}
        stateData={{ selectedTab: "supportRequests" }}
        stateDataPage={{ page: currentPage }}
        search={search}
      />
      {sort == "" && (
        <div className="col-12 col-md-8 col-lg-4 d-flex gap-2 mb-3">
          <input
            type="search"
            className="form-control py-3"
            placeholder="Search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            onKeyDown={(e) => e.key === "Enter" && getTableDataSearch()}
          />
          <button
            className="btn btn-primary py-3 px-3"
            onClick={getTableDataSearch}
          >
            <i className="fa fa-search" />
          </button>
        </div>
      )}

      <Card>
        <Card.Body>
          {/* <!-- Nav tabs --> */}
          <div className="default-tab">
            <Tab.Container activeKey={selectedTab}>
              {!dataId && <Nav as="ul" className="nav-tabs">
                {tabData.map((data, i) => (
                  <Nav.Item as="li" key={i}>
                    <Nav.Link
                      eventKey={data.name}
                      onClick={() => {
                        if (data.name === "Help Center") {
                          setSort("new");
                          setSelectedTab(data.name);
                          setCurrentPage(0);
                          setSearch("");
                          return;
                        }
                        setSort(
                          data.name.toLowerCase() === "search"
                            ? ""
                            : data.name.toLowerCase()
                        );
                        setSelectedTab(data.name);
                        setCurrentPage(0);
                        setSearch("");
                      }}
                    >
                      <i className={`la la-${data.icon} me-2`} />
                      {data.content}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>}
              <Tab.Content className="pt-4">
                {tabData.map((data, i) => (
                  <Tab.Pane
                    eventKey={data.name}
                    onClick={() => setSelectedTab(data.name)}
                    key={i}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="col-6">
                        {/* <div
                          className="input-group border bg-white input-group-sm"
                          style={{ borderRadius: "8px" }}
                        >
                          <input
                            style={{
                              paddingBottom: "25px",
                              paddingTop: "25px",
                              borderRadius: "10px",
                              fontSize: "14px",
                            }}
                            type="text"
                            name="table_search"
                            className="form-control float-right border-0"
                            placeholder="Search"
                            onChange={(e) => setSearch(e.target.value)}
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-default"
                              onClick={getTableData}
                            >
                              <i className="fa fa-search" />
                            </button>
                          </div>
                        </div> */}
                      </div>
                    </div>

                    {loader ? (
                      <Spinner />
                    ) : (
                      <Table responsive className="mostly-customized-scrollba">
                        <thead style={{ color: "black" }}>
                          <tr>
                            {selectedTab !== "Help Center" && (
                              <th>
                                <strong>ticket no.</strong>
                              </th>
                            )}
                            {selectedTab !== "Help Center" && (
                              <th>
                                <strong>NAME</strong>
                              </th>
                            )}
                            <th>
                              <strong>Id</strong>
                            </th>
                            <th>
                              <strong>{selectedTab === "Help Center" ? "Help With" : "Category"}</strong>
                            </th>
                            <th>
                              <strong>{selectedTab === "Help Center" ? "Issue Type" : "Issue type"}</strong>
                            </th>
                            <th>
                              <strong>message</strong>
                            </th>
                            <th>
                              <strong>date</strong>
                            </th>
                            {selectedTab !== "Help Center" && (
                              <th>
                                <strong>STATUS</strong>
                              </th>
                            )}
                            {selectedTab !== "Help Center" && (
                              <th>
                                <strong>ACTION</strong>
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {datas &&
                            datas?.map((item, i) => (
                              <tr
                                key={i}
                                style={{ cursor: selectedTab === "Help Center" ? "pointer" : "default", fontSize: "14px" }}
                                onClick={() => {
                                  if (selectedTab === "Help Center") openDetails(item);
                                }}
                              >
                                {selectedTab !== "Help Center" && <td>{item.ticket}</td>}
                                {selectedTab !== "Help Center" && (
                                  <td
                                    onClick={() => {
                                      if (item?.user) {
                                        navigate("/user-details", {
                                          state: {
                                            data: item?.user,
                                            path: "/support-requests",
                                            page: currentPage,
                                            selectedTab: { selectedTab },
                                            from: "supportRequests",
                                          },
                                        });
                                      } else {
                                        toast.error(
                                          "This ticket was raised from the Get in Touch page by a non-logged-in user. User profile details are not available."
                                        );
                                      }
                                    }}
                                    className="pointer"
                                  >
                                    {item.name}
                                  </td>
                                )}
                                <td>
                                  {selectedTab === "Help Center"
                                    ? item?.email || item?.phone || "-"
                                    : item.email}
                                </td>
                                <td className="text-capitalize">
                                  {selectedTab === "Help Center"
                                    ? helpOptionLabelByKey(item?.helpWith)
                                    : item.category}
                                </td>
                                <td className="text-capitalize">
                                  {selectedTab === "Help Center"
                                    ? helpCenterTypeLabel(item)
                                    : item.type}
                                </td>
                                <td
                                  style={{
                                    minWidth: "300px",
                                    whiteSpace: "normal",
                                    overflowWrap: "anywhere",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  <div className="d-flex flex-column gap-2">
                                    <div>
                                      {selectedTab === "Help Center"
                                        ? truncateWords(
                                            item?.description || item?.message,
                                            5
                                          )
                                        : item?.message || "-"}
                                    </div>
                                    {selectedTab === "Help Center" && (
                                      <div className="d-flex flex-wrap gap-2 text-muted">
                                        {!!item?.platform && (
                                          <span className="badge light badge-secondary">
                                            {optionLabel(PLATFORM_OPTIONS, item.platform)}
                                          </span>
                                        )}
                                        {!!item?.chargeOnStatement && (
                                          <span className="badge light badge-secondary">
                                            {optionLabel(
                                              CHARGE_ON_STATEMENT_OPTIONS,
                                              item.chargeOnStatement
                                            )}
                                          </span>
                                        )}
                                      </div>
                                    )}
                                    {selectedTab === "Help Center" &&
                                      Array.isArray(item?.attachments) &&
                                      item.attachments.length > 0 && (
                                        <div className="d-flex flex-wrap gap-2">
                                          {item.attachments.map((path, idx) => {
                                            const url = `${imgBaseURL}${path}`;
                                            return (
                                              <img
                                                key={`${item._id || i}-${idx}`}
                                                src={url}
                                                alt="attachment"
                                                className="pointer rounded border"
                                                style={{
                                                  width: 44,
                                                  height: 44,
                                                  objectFit: "cover",
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  // Row click opens details; thumbnail click opens image viewer.
                                                  setAttachmentForView(url);
                                                  setShowAttachmentModal(true);
                                                }}
                                              />
                                            );
                                          })}
                                        </div>
                                      )}
                                  </div>
                                </td>
                                <td>
                                  {moment(item?.createdAt).format(
                                    "DD/MM/YYYY, hh:mm A"
                                  )}
                                </td>
                                {selectedTab !== "Help Center" && (
                                  <td>
                                    {(() => {
                                      const statusRaw = item?.status || "";
                                      const status = String(statusRaw).toLowerCase();

                                      // UI mapping:
                                      // Open -> red, In Progress -> orange, Resolved -> green
                                      // Backend values seen here: "inProgress", "resolved", "close"
                                      const badgeClass =
                                        status === "inprogress"
                                          ? "badge-warning"
                                          : status === "resolved" || status === "close"
                                            ? "badge-success"
                                            : "badge-danger";

                                      const label =
                                        status === "inprogress"
                                          ? "In Progress"
                                          : status === "resolved"
                                            ? "Resolved"
                                            : status === "close"
                                              ? "Resolved"
                                              : "Open";

                                      return (
                                        <Badge bg="" className={badgeClass}>
                                          {label}
                                        </Badge>
                                      );
                                    })()}
                                  </td>
                                )}
                                {selectedTab !== "Help Center" && (
                                  <td>
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        variant="info light"
                                        className="light sharp btn btn-info i-false"
                                      >
                                        {svg1}
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu>
                                        {item?.status === "close" ? (
                                          ""
                                        ) : item?.status === "inProgress" ? (
                                          <Dropdown.Item
                                            onClick={() =>
                                              onAction(item._id, "resolved")
                                            }
                                          >
                                            Resolved
                                          </Dropdown.Item>
                                        ) : (
                                          <>
                                            <Dropdown.Item
                                              onClick={() =>
                                                onAction(item._id, "inProgress")
                                              }
                                            >
                                              Inprogress
                                            </Dropdown.Item>

                                            <Dropdown.Item
                                              onClick={() =>
                                                onAction(item._id, "resolved")
                                              }
                                            >
                                              Resolved
                                            </Dropdown.Item>
                                          </>
                                        )}

                                        <Dropdown.Item
                                          onClick={() => openDeleteConfirm(item._id, "support")}
                                        >
                                          Delete
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                )}
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    )}
                    {datas?.length === 0 && !loader ? (
                      <div className="justify-content-center d-flex my-5 ">
                        Sorry, Data Not Found!
                      </div>
                    ) : (
                      ""
                    )}
                    {datas?.length !== 0 && (
                      <div className="card-footer clearfix">
                        <div className="d-block d-sm-flex justify-content-between align-items-center">
                          <div className="dataTables_info">
                            Showing {currentPage * limit + 1} to{" "}
                            {listLength > (currentPage + 1) * limit
                              ? (currentPage + 1) * limit
                              : listLength}{" "}
                            of {listLength} entries
                          </div>
                          <Pagination
                            pageCount={pageCount}
                            pageValue={currentPage}
                            setPage={setCurrentPage}
                          />
                        </div>
                      </div>
                    )}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Tab.Container>
          </div>
        </Card.Body>
      </Card>
      <FullImage
        show={showAttachmentModal}
        image={attachmentForView}
        imageType="image"
        onHide={() => setShowAttachmentModal(false)}
      />

      <Modal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        size="lg"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Support Request Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {detailsItem ? (
            <>
              <Table bordered responsive>
                <tbody>
                  {(() => {
                    const preferredOrder = [
                      "_id",
                      "helpWith",
                      "safetyConcern",
                      "type",
                      "loginDetail",
                      "billingDetail",
                      "email",
                      "phone",
                      "description",
                      "chargeOnStatement",
                      "chargeDescription",
                      "platform",
                      "device",
                      "orderNumber",
                      "featureTopic",
                      "safetyReportContentKind",
                      "safetyPhysicalHarmDetail",
                      "safetyImpersonationKind",
                      "safetyProfileLocation",
                      "safetyCopyrightRole",
                      "hasSubscription",
                      "createdAt",
                    ];

                    // Hide any backend keys you don't want to display in modal
                    const EXCLUDED_DETAIL_KEYS = new Set(["__v", "_id","updatedAt","isDeleted"]);

                    const keys = Object.keys(detailsItem || {}).filter((k) => {
                      if (EXCLUDED_DETAIL_KEYS.has(k)) return false;
                      if (k === "attachments") return true;
                      return detailsItem?.[k] !== undefined;
                    });

                    const ordered = [
                      ...preferredOrder.filter((k) => keys.includes(k)),
                      ...keys
                        .filter((k) => !preferredOrder.includes(k))
                        .sort((a, b) => a.localeCompare(b)),
                    ];

                    return ordered.map((key) => {
                      if (key === "attachments") {
                        return (
                          <tr key={key}>
                            <td style={{ width: 220 }}>
                              <strong>{prettifyKey(key)}</strong>
                            </td>
                            <td>
                              {Array.isArray(detailsItem?.attachments) &&
                                detailsItem.attachments.length > 0 ? (
                                <div className="d-flex flex-wrap gap-2">
                                  {detailsItem.attachments.map((path, idx) => {
                                    const url = `${imgBaseURL}${path}`;
                                    return (
                                      <img
                                        key={`${detailsItem._id || "details"}-${idx}`}
                                        src={url}
                                        alt="attachment"
                                        className="pointer rounded border"
                                        style={{
                                          width: 60,
                                          height: 60,
                                          objectFit: "cover",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setAttachmentForView(url);
                                          setShowAttachmentModal(true);
                                        }}
                                      />
                                    );
                                  })}
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        );
                      }

                      const rawValue = detailsItem?.[key];
                      const formatted = formatDetailsValue(key, rawValue, detailsItem);

                      const isMultiline =
                        typeof formatted === "string" &&
                        (formatted.includes("\n") || formatted.length > 120);

                      return (
                        <tr key={key}>
                          <td style={{ width: 220 }}>
                            <strong>{prettifyKey(key)}</strong>
                          </td>
                          <td style={isMultiline ? { whiteSpace: "pre-wrap" } : undefined}>
                            {formatted}
                          </td>
                        </tr>
                      );
                    });
                  })()}
                </tbody>
              </Table>
            </>
          ) : (
            <div className="text-muted">No details available.</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() => openDeleteConfirm(detailsItem?._id, "helpCenter")}
            disabled={!detailsItem?._id || loader}
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteConfirmModal}
        onHide={closeDeleteConfirm}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this support request? This action can’t
          be undone.
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-light"
            onClick={closeDeleteConfirm}
            disabled={loader}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger"
            onClick={confirmDelete}
            disabled={loader || !deleteConfirmId}
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
